import { NotificationTemplate } from "./notification-template.model";
import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { Observable } from "rxjs/Observable";

export class NotificationTemplateApiFacade extends AccountObjectApiFacade<NotificationTemplate> {

    get(accountId: string, id: string, options: ApiRequestOptions): Observable<NotificationTemplate> {
        return this.GET(`/accounts/${accountId}/notificationtemplates/${id}`, options)
            .map(object => new NotificationTemplate(object));
    }

    getAll(accountId: string, id: string, options: ApiRequestOptions): Observable<Array<NotificationTemplate>> {
        return this.CGET(`/accounts/${accountId}/notificationtemplates`, options)
            .map(objects => objects.map(object => new NotificationTemplate(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/notification-template/notification-template.api-facade.ts